import { memo } from "react";
import Image from "next/image";
import EthImageUrl from "./assets/eth.png";
import CommunityImageUrl from "./assets/community.png";
import { DAO } from "../../../model/info-about-bootcamp";

interface Props {
  data: DAO;
}

export const Dao = memo<Props>(({ data }) => {
  return (
    <div className="rounded-t-[20px] lg:pl-10 lg:pr-10 bg-black pr-5 pl-5 pt-24 lg:pt-36 lg:pt-40 pb-20 lg:pb-40">
      <div className="text-[15px] leading-[16px] text-uppercase m-auto w-fit rounded-[40px] border border-solid border-lime pr-6 pl-6 pt-2 pb-2 lg:pt-3 lg:pb-3 lg:pl-9 lg:pr-9 text-center text-lime">
        DAO
      </div>
      <h2
        // eslint-disable-next-line
        dangerouslySetInnerHTML={{
          __html: data.title,
        }}
        className="mt-6 pb-20 lg:pb-28 text-center text-white text-[32px] leading-[34px] lg:text-[58px] lg:leading-[60px]"
      />

      <div className="m-auto mb-5 flex max-w-[1200px] flex-wrap justify-center">
        <div className="mb-5 lg:mb-0 lg:mr-5 max-w-[618px] rounded-[20px] bg-[#15191B] pt-12 pb-12 pl-8 pr-8 lg:pt-17 lg:pb-17 lg:pl-20 lg:pr-20">
          <div
            // eslint-disable-next-line
            dangerouslySetInnerHTML={{
              __html: data.list[0].title,
            }}
            className="text-[20px] leading-[30px] lg:text-[28px] lg:leading-[30px] text-white"
          />
          {data.list[0].description && (
            <div
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: data.list[0].description,
              }}
              className="pt-6 text-night-base-base-400"
            />
          )}
        </div>
        <div className="relative w-full lg:w-fit lg:max-w-[536px] rounded-[20px] bg-[#15191B] pt-12 pb-12 pl-8 pr-8 lg:pt-17 lg:pb-17 lg:pl-20 lg:pr-20 text-[22px] leading-[29px] text-white">
          <div
            // eslint-disable-next-line
            dangerouslySetInnerHTML={{
              __html: data.list[1].title,
            }}
            className="text-center lg:mb-5 lg:mb-0 text-[110px] leading-[120px] lg:text-[170px] lg:leading-[224px] text-white"
          />
          <div className="absolute right-[-30px] top-[-20px] lg:right-[-100px] lg:top-[-70px] max-w-[96px] lg:max-w-[166px] rotate-[20deg]">
            <Image src={CommunityImageUrl} alt="Community image" />
          </div>
          {data.list[1].description && (
            <div
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: data.list[1].description,
              }}
              className="lg:pt-10 text-center text-night-base-base-400"
            />
          )}
        </div>
      </div>
      <div className="m-auto mb-5 flex max-w-[1200px] flex-wrap justify-center">
        <div className="mb-5 lg:mb-0 relative lg:mr-5 w-full lg:w-fit lg:min-w-[400px] rounded-[20px] bg-[#15191B] pt-12 pb-12 pl-8 pr-8 lg:pt-17 lg:pb-17 lg:pl-20 lg:pr-20 text-[22px] leading-[29px] text-white">
          <div
            // eslint-disable-next-line
            dangerouslySetInnerHTML={{
              __html: data.list[2].title,
            }}
            className="text-center text-[110px] leading-[120px] lg:text-[170px] lg:leading-[224px] text-white"
          />
          {data.list[2].description && (
            <div
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: data.list[2].description,
              }}
              className="lg:pt-10 text-center text-night-base-base-400"
            />
          )}
          <div className="absolute left-[-30px] top-[-45px] lg:left-[-80px] lg:top-[5px] max-w-[130px] lg:max-w-[166px] rotate-[-20deg]">
            <Image src={EthImageUrl} alt="Eth image" />
          </div>
        </div>
        <div className="max-w-[610px] rounded-[20px] bg-[#15191B] pt-12 pb-12 pl-8 pr-8 lg:pt-17 lg:pb-17 lg:pl-20 lg:pr-20">
          <div
            // eslint-disable-next-line
            dangerouslySetInnerHTML={{
              __html: data.list[3].title,
            }}
            className="text-[20px] leading-[30px] lg:text-[28px] lg:leading-[30px] text-white"
          />
          {data.list[3].description && (
            <div // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: data.list[3].description,
              }}
              className="pt-10 text-night-base-base-400"
            />
          )}
        </div>
      </div>
      <div className="m-auto mb-5 flex max-w-[1200px] flex-wrap justify-center">
        <div className="mb-5 lg:mb-0 lg:mr-5 w-full lg:w-fit lg:max-w-[400px] rounded-[20px] bg-[#15191B] pt-12 pb-12 pl-8 pr-8 lg:pt-17 lg:pb-17 lg:pl-20 lg:pr-20 text-white">
          <div
            // eslint-disable-next-line
            dangerouslySetInnerHTML={{
              __html: data.list[4].title,
            }}
            className="text-[20px] leading-[30px] lg:text-[28px] lg:leading-[30px] text-white"
          />
          {data.list[4].description && (
            <div // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: data.list[4].description,
              }}
              className="pt-10 text-night-base-base-400"
            />
          )}
        </div>
        <div className="grid grid-cols-2 gap-[10px] w-full lg:w-fit">
          <div className="rounded-[20px] bg-[#15191B] pt-12 pb-12 pl-8 pr-8 lg:pt-17 lg:pb-17 lg:pl-20 lg:pr-20">
            <div
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: data.list[5].title,
              }}
              className="lg:min-w-[220px] text-center text-[110px] leading-[120px] lg:text-[170px] lg:leading-[224px] text-white"
            />
            {data.list[5].description && (
              <div
                // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: data.list[5].description,
                }}
                className="pt-10 text-center text-night-base-base-400"
              />
            )}
          </div>
          <div className="rounded-[20px] bg-[#15191B] pt-12 pb-12 pl-8 pr-8 lg:pt-17 lg:pb-17 lg:pl-20 lg:pr-20">
            <div
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: data.list[6].title,
              }}
              className="lg:min-w-[220px] text-center text-[110px] leading-[120px] lg:text-[170px] lg:leading-[224px] text-white"
            />
            {data.list[6].description && (
              <div
                // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: data.list[6].description,
                }}
                className="pt-10 text-center text-night-base-base-400"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
